import { makeStyles } from "@material-ui/styles"

const useStyle = makeStyles(() => ({
  autocomplete: {
    height: "max-content",
    maxWidth: 260,
    marginRight: 8,
  },
}));

export default useStyle;
